import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { UserContext } from '../context/UserContext';
import LeadAgentNoticeDialog from './LeadAgentNoticeDialog';
import { USER_ROLES } from '../constants';

const Layout = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  const showSidebar = !!user?.role && !isMobileOrTablet && !(user?.role === USER_ROLES.LEAD_AGENT && !user?.isApproved);

  const isLeadAgent = user?.role?.toLowerCase().replace(/[-_\s]/g, '') === 'leadagent';

  const isNotAgreed = !sessionStorage.getItem('leadAgentNoticeAccepted');
  const isTermsPage =
    location.pathname.startsWith('/content/') && !location.pathname.startsWith('/content/articles');

  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    if (isLeadAgent && isNotAgreed) {
      setShowDialog(true);
    }
  }, [isLeadAgent, isNotAgreed]);

  const handleAccept = () => {
    sessionStorage.setItem('leadAgentNoticeAccepted', 'true');
    setShowDialog(false);
  };

  return (
    <Box height='100dvh' width='100%' maxWidth='100%' display='flex' flexDirection='column' overflow='hidden'>
      <Navbar />
      <Box display='flex' alignItems='stretch' flexGrow={1} height={0} minHeight={0} minWidth={0}>
        {showSidebar && !isTermsPage && <Sidebar />}
        <Box
          id='content-container'
          flex='1'
          width={0}
          minWidth={0}
          minHeight={0}
          height='100%'
          display='flex'
          flexDirection='column'
          bgcolor='#fafafa'
          overflow='auto'
          sx={{ scrollBehavior: 'smooth' }}
        >
          {children}
        </Box>
      </Box>

      {/* Show the dialog on top of layout */}
      {isLeadAgent && showDialog && <LeadAgentNoticeDialog onAccept={handleAccept} />}
    </Box>
  );
};

export default Layout;
